import { Product } from "../interfaces/product.interface";

export const mockProducts: Product[] = [
  {
    id: "copy-pack",
    name: "AI 廣東話社群文案包 (10款風格)",
    description:
      "數萬條香港高轉化廣告同連登潮語訓練，一次出齊 10 款唔同風格嘅廣東話 IG / FB 文案，旺角 sales 貼地定中環 OL 專業任你揀。",
    price: 580,
    imageUrl: "/images/products/product-copy-pack.png",
    category: "AI 文案",
    rating: 4.9,
    reviewCount: 328,
    highlights: ["10 款風格", "正宗廣東話", "30 秒出貨"],
    stock: 999,
  },
  {
    id: "feed-images",
    name: "AI 視覺設計 Feed 圖 + Product 宣傳片 (5圖 + 1片)",
    description:
      "自動配對品牌色同產品圖，一次出齊 5 張港風 IG Feed 排版圖，再加 1 片 Product 宣傳短片，圖文片三合一，唔使再執到凌晨。",
    price: 780,
    imageUrl: "/images/products/product-feed-images.png",
    category: "AI 視覺",
    rating: 4.8,
    reviewCount: 256,
    highlights: ["5圖 + 1片", "Product 宣傳片", "港風審美"],
    stock: 999,
  },
  {
    id: "whatsapp-automation",
    name: "香港電商自動化 WhatsApp/IG 行銷劇本",
    description:
      "專為香港電商設計嘅自動追單、回 PM、催付款劇本，WhatsApp 同 IG 雙平台適用，半夜都幫你收單。",
    price: 880,
    imageUrl: "/images/products/product-whatsapp-automation.png",
    category: "自動化",
    rating: 4.9,
    reviewCount: 189,
    highlights: ["WhatsApp + IG", "自動追單", "24/7 運作"],
    stock: 999,
  },
  {
    id: "full-bundle",
    name: "AI 港式全套宣傳包 (A + B + C)",
    description:
      "文案、Feed 圖 + Product 宣傳片、自動化行銷劇本一次過齊，開舖必備皇牌組合。90% 電商老闆首選，慳錢又慳時間。",
    price: 1050,
    originalPrice: 2240,
    imageUrl: "/images/products/product-full-bundle.png",
    category: "皇牌套裝",
    rating: 5,
    reviewCount: 512,
    isFeatured: true,
    featuredLabel: "皇牌推薦",
    savingsLabel: "激慳 $1,190，90% 電商老闆首選",
    highlights: ["A+B+C 全包", "慳 $1,190", "30 秒出貨"],
    stock: 999,
  },
];

export const getProductById = (id: string): Product | undefined =>
  mockProducts.find((p) => p.id === id);
